/**
 * Persistencia de la Declaración de Renta F-22 AT 2025, Régimen 14 D N°8. El mapeo y
 * el cálculo son los comunes del régimen (../../14d8/persistence.js); lo lee el backend
 * (src/services/declaracionRenta/schemas/2025_14d8.js) y el frontend (vía el registry).
 */
const { crearPersistencia14d8 } = require('../../14d8/persistence');

module.exports = crearPersistencia14d8(2025);
